import React, { memo, useCallback } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

/* components */
import ReactDatePicker from 'react-datepicker'

/* styles */
import 'react-datepicker/dist/react-datepicker.css'
import classes from './DatePicker.module.scss'

// datepickerClassName
const DatePicker = ({
  label,
  className,
  labelColor,
  datepickerClassName,
  error,
  inputClassName,
  style,
  placeholderText,
  onChange,
  name,
  fieldName,
  ...restProps
}) => {

  const { t } = useTranslation('common_volunteering')
  const memoT = useCallback((val) => t(val), [t])

  const handleChange = useCallback(
    (value) => onChange(value, fieldName),
    [onChange, fieldName],
  )

  return (
    <label
      className={clsx(
        classes.datepicker,
        className,
      )}
      style={style || null}>
      {label && (
        <div
          className={clsx(
            classes.label,
            error && classes.errorText,
          )}
          style={labelColor ? { color: labelColor } : null}>
          {memoT(label)}
        </div>
      )}

      <ReactDatePicker
        className={clsx(
          inputClassName || classes.input,
          datepickerClassName,
          error && classes.errorBorder,
        )}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        placeholderText={memoT(placeholderText)}
        onChange={handleChange}
        {...restProps}
      />

      {error && (
        <div
          className={clsx(
            'text-right',
            classes.errorText,
          )}>
          {error}
        </div>
      )}
    </label>
  )
}

DatePicker.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  className: PropTypes.string,
  datepickerClassName: PropTypes.string,
}

export default memo(DatePicker)
